var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cooperation" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("common.cooperTip"))),
      ]),
      _c("div", { staticClass: "info hidden-sm-and-down" }, [
        _vm._v(
          _vm._s(
            _vm.$t("common.cooperConsultPhone") +
              "：" +
              _vm.$t("common.phone") +
              " " +
              _vm.$t("common.principal") +
              "：" +
              _vm.$t("common.MrXie")
          )
        ),
      ]),
      _c("div", { staticClass: "info hidden-md-and-up" }, [
        _c("div", [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("common.cooperConsultPhone") +
                  "：" +
                  _vm.$t("common.phone")
              )
          ),
        ]),
        _c("div", [
          _vm._v(
            _vm._s(_vm.$t("common.principal") + "：" + _vm.$t("common.MrXie"))
          ),
        ]),
      ]),
      _c("avue-form", {
        attrs: { option: _vm.option },
        on: { submit: _vm.submit },
        model: {
          value: _vm.form,
          callback: function ($$v) {
            _vm.form = $$v
          },
          expression: "form",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }